class LiftoffDebugger {
  static init(debuggerContext) {
    this.el = document.createElement("div");
    this.el.classList.add("liftoff-debugger");
    Object.assign(this.el.style, {
      position: "fixed",
      top: 0,
      left: 0,
      zIndex: 9999,
      fontSize: "12px",
      background: "aqua",
      minWidth: "15px",
      minHeight: "15px",
      overflowY: "auto",
      userSelect: "none",
      opacity: 0.9,
    });

    this.debuggerContext = debuggerContext;
    this.viewportSizes = [];
    this.showing = true;

    this.addEventListeners();
    this.testViewport();
    this.render();

    document.body.appendChild(this.el);
  }

  static addEventListeners() {
    window.addEventListener("resize", () => {
      if (this.testViewport()) this.render();
    });

    this.el.addEventListener("click", () => {
      this.showing = !this.showing;
      this.el.style.display = this.showing ? "block" : "none";
    });
  }

  static testViewport() {
    const { innerWidth: width, innerHeight: height } = window;
    const len = this.viewportSizes.length;
    const [lastWidth, lastHeight] =
      len > 0 ? this.viewportSizes[len - 1] : [-1, -1];
    if (width !== lastWidth || height !== lastHeight) {
      this.viewportSizes.push([width, height]);
      this.el.style.maxHeight = height;
      return true;
    }
  }

  static render() {
    const {
      ab_tests,
      bid_request_id,
      creative_id,
      exchange,
      platform,
      viewclick_html_interstitial,
      viewclick_vast_interstitial,
      use_ios_pod,
      use_liftoff_pod,
      targeted_countries,
    } = this.debuggerContext;

    const liftoffMRAID =
      (window.Liftoff && window.Liftoff.LiftoffMRAID) || window.LiftoffMRAID;
    const supportsMraid =
      liftoffMRAID != null
        ? liftoffMRAID.hasSupport("mraid")
        : window.mraid != null;
    const umbrellaInfo = `${viewclick_html_interstitial ? "viewclick-html" : ""}
    ${viewclick_vast_interstitial ? "viewclick-vast" : ""}
    ${use_ios_pod ? "use-ios-pod" : ""}
    ${use_liftoff_pod ? "use-liftoff-pod" : ""}
    `;
    this.el.innerHTML = `
    br_id ${bid_request_id}<br>
    ${creative_id} ${exchange || ""} ${platform} ${
      supportsMraid ? "MRAID" : ""
    }<br>
    ${this.viewportSizes.map((s) => (s ? s.join("x") : "?")).join(" ")}<br>
    ${umbrellaInfo.trim() === "" ? "" : umbrellaInfo + "<br>"}
    ${ab_tests ? ab_tests.join("<br>") : ""}
    ${targeted_countries ? targeted_countries.join(" ") : ""}
    `;
  }
}

window.LiftoffDebugger = LiftoffDebugger;



// WEBPACK FOOTER //
// ./src/js/madlib/liftoff_debugger.js